import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GtagService } from './gtag.service';
import { MetaPixelService } from './meta-pixel.service';

/**
 * Subscribes to router navigation and sends a page view to Google Analytics (gtag)
 * and Meta Pixel on every route change, so every page is tracked in both systems.
 * Event tracking (contact form, dealer clicks, etc.) is unchanged and handled in components.
 */
@Injectable({
    providedIn: 'root'
})
export class AnalyticsPageViewService {
    private _initialized = false;

    constructor(
        private _router: Router,
        private _gtagService: GtagService,
        private _metaPixelService: MetaPixelService
    ) {}

    init(): void {
        if (this._initialized) {
            return;
        }

        this._initialized = true;
        this.trackPageView(this._router.url);

        this._router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.trackPageView(event.urlAfterRedirects ?? event.url ?? this._router.url);
            });
    }

    private trackPageView(url: string): void {
        const path = url?.split('?')[0] ?? this._router.url;
        this._gtagService.pageView(path);
        this._metaPixelService.track('PageView');
    }
}
